import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import Link from 'next/link'
import axios from '@/lib/axios'
import Loading from '@/components/Loading'
import { fetchPricingLocaleClient } from '@/lib/localeCountryGuess'

const fetcher = url => axios.get(url).then(r => r.data)

function Pricing() {
    const [clientLocale, setClientLocale] = useState(null)

    useEffect(() => {
        let cancelled = false
        ;(async () => {
            try {
                const data = await fetchPricingLocaleClient()
                if (!cancelled) setClientLocale(data)
            } catch (e) {
                console.error(e)
                if (!cancelled) {
                    setClientLocale({
                        countryName: 'Afghanistan',
                        currency: '',
                        region: null,
                    })
                }
            }
        })()
        return () => {
            cancelled = true
        }
    }, [])

    const effectiveCountry = clientLocale?.countryName || 'Afghanistan'
    const { data: pricingDataState, error: packagesError, isLoading } = useSWR(
        clientLocale
            ? `/api/packages/filter?country_name=${encodeURIComponent(effectiveCountry)}`
            : null,
        fetcher,
    )

    if (packagesError) return <div>Failed to load packages</div>
    if (!clientLocale || isLoading || !pricingDataState) return <Loading />

    return (
        <div>
            {effectiveCountry && (
                <div className="pricing-card-wrapper-dasktop">
                    <div className="row justify-center">
                        {Array.isArray(pricingDataState) && pricingDataState.length > 0 ? (
                            pricingDataState.map((item, id) =>
                                item.status == 1 ? (
                                    <div className="col-md-3" key={id}>
                                        <div
                                            className="pricing-chard-item"
                                            key={id}>
                                            <div className="pricing-card-list">
                                                <h3>{item.name}</h3>
                                            </div>
                                            <div className="pricing-card-list price">
                                                <h2>
                                                    <span>
                                                        {clientLocale?.currency || ''}{' '}
                                                    </span>
                                                    {item.price}
                                                </h2>
                                                <p>{item?.id == 2 ? '1 Year' : '1 Month'}</p>

                                            </div>
                                            <div className="pricing-card-list-qr">
                                                <ul>
                                                    <li>
                                                        <p>Dynamic QR Code</p>
                                                        <p className="pricing-count">
                                                            {item.qr_qt}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Scan</p>
                                                        <p className="pricing-count">
                                                            {item.scan_limit}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Website QR</p>
                                                        <p className="pricing-count">
                                                            {
                                                                item.website_qr_limit
                                                            }
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Card </p>
                                                        <p className="pricing-count">
                                                            {item.card}
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="pricing-description">
                                                <Link
                                                    href={`/package/[id]`}
                                                    as={`/package/${item.id}`}
                                                    legacyBehavior
                                                    passHref>
                                                    <a className="custom-btn priching-cart-btn">
                                                        Add to Cart
                                                    </a>
                                                </Link>
                                                <div
                                                    className="pricing-des pricing-cart-list"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.description,
                                                    }}></div>
                                                {/* <div className="pricing-cart-list">
                                                    <ul>
                                                        <li>
                                                            Unlimited taps/cards
                                                            shares
                                                        </li>

                                                    </ul>
                                                </div> */}
                                            </div>
                                            {item.qr_most_text && (
                                                <div className="most-popular-label">
                                                    {item.qr_most_text}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : null,
                            )
                        ) : (
                            <div>No packages available</div>
                        )}
                    </div>
                </div>
            )}
            {effectiveCountry && (
                <div className="pricing-card-wrapper-mobile">
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={25}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            600: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            1200: { slidesPerView: 4 },
                        }}
                        className="mySwiper">
                        {Array.isArray(pricingDataState) && pricingDataState.length > 0 ? (
                            pricingDataState.map((item, id) =>
                                item.status == 1 ? (
                                    <SwiperSlide key={id}>
                                        <div className="pricing-chard-item">
                                            <div className="pricing-card-list">
                                                <h3>{item.name}</h3>
                                            </div>
                                            <div className="pricing-card-list price">
                                                <h3>
                                                    <span>
                                                        {clientLocale?.currency || ''}{' '}
                                                    </span>
                                                    {item.price}
                                                </h3>
                                                <p>1 Month</p>
                                            </div>
                                            <div className="pricing-card-list-qr">
                                                <ul>
                                                    <li>
                                                        <p>Dynamic QR Code</p>
                                                        <p className="pricing-count">
                                                            {item.qr_qt}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Scan</p>
                                                        <p className="pricing-count">
                                                            {item.scan_limit}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Website QR</p>
                                                        <p className="pricing-count">
                                                            {
                                                                item.website_qr_limit
                                                            }
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>Ecommerce </p>
                                                        <p className="pricing-count">
                                                            {item.card}
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="pricing-description">
                                                <Link
                                                    href={`/package/[id]`}
                                                    as={`/package/${item.id}`}
                                                    legacyBehavior
                                                    passHref>
                                                    <a className="custom-btn">
                                                        Add to Cart
                                                    </a>
                                                </Link>

                                                <div
                                                    className="pricing-des pricing-cart-list"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.description,
                                                    }}></div>

                                            </div>

                                        </div>
                                    </SwiperSlide>
                                ) : null,
                            )
                        ) : (
                            <div>No packages available</div>
                        )}
                    </Swiper>
                </div>
            )}
        </div>
    )
}

export default Pricing
